module.exports = "/assets/8df90822b049a6b65e0f84a36ad4d621.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/ZL.png
// module id = 3185
// module chunks = 0